import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './CookieConsent.css'; // We'll create this for specific styles if needed

const CookieConsent = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const consentGiven = localStorage.getItem('cookieConsent');
    if (!consentGiven) {
      setIsVisible(true);
    } else {
      // Optional: Check for consent renewal
      const timestamp = localStorage.getItem('cookieConsentTimestamp');
      if (timestamp) {
        const consentDate = new Date(parseInt(timestamp));
        const now = new Date();
        const sixMonthsInMs = 6 * 30 * 24 * 60 * 60 * 1000; // Approx 6 months
        if (now - consentDate > sixMonthsInMs) {
          localStorage.removeItem('cookieConsent');
          localStorage.removeItem('cookieConsentTimestamp');
          setIsVisible(true);
        }
      }
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookieConsent', 'accepted');
    localStorage.setItem('cookieConsentTimestamp', Date.now().toString());
    setIsVisible(false);
    // enableAllCookies(); // Placeholder for actual cookie enabling logic
    console.log("All cookies accepted");
  };

  const handleDecline = () => {
    localStorage.setItem('cookieConsent', 'declined');
    localStorage.setItem('cookieConsentTimestamp', Date.now().toString());
    setIsVisible(false);
    // disableNonEssentialCookies(); // Placeholder for actual cookie disabling logic
    console.log("Non-essential cookies declined");
  };

  if (!isVisible) {
    return null;
  }

  return (
    <div id="cookieConsentBanner" className="cookie-banner">
      <div className="cookie-content">
        <h3>Cookie Notice</h3>
        <p>
          We use cookies to improve your experience and to analyze site usage. 
          By continuing to browse, you agree to our use of cookies as described in our{' '}
          <Link to="/privacy">Privacy Policy</Link>.
        </p>
        <div className="cookie-buttons">
          <button id="cookieAccept" className="cookie-accept" onClick={handleAccept}>
            Accept All
          </button>
          <button id="cookieDecline" className="cookie-decline" onClick={handleDecline}>
            Essential Only
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent; 